<div class="base-container narrow">
    <div class="d-flex mt-3">
        <h2 class="my-0">News</h2>
        <div class="ml-auto d-flex">
            <button type="button" class="btn strict-sized-button-large font-bold {{!offersOnly? 'btn-primary' : 'btn-light'}} undisable"  (click)="showAll()">Alle</button>
            <button type="button" class="btn strict-sized-button-large font-bold {{offersOnly? 'btn-primary' : 'btn-light'}} undisable"  (click)="showOffersOnly()">Aktionen</button>
        </div>
    </div>
    <hr class="divider my-1">
    <div>
        <div class="news-banner">
            News und Aktionen
        </div>
        <div class="news-wrapper">
            <div class="one-new-wrapper" *ngFor="let newsletter of getNewsletters()">
                <!-- <div class="one-new" [routerLink]="['./', newsletter.id]"> -->
                <a [href]="newsletter.htmlLink" target="_blank" class="one-new">
                    <div class="title-with-date">
                        <div class="font-bolder big"> {{ newsletter.subject }}</div>
                        <div class="small"> {{ newsletter.startDate | date:'dd MMM yyyy' }}</div>
                    </div>
                    <div class="ml-auto my-auto news-link"> Mehr Informationen <bd-fa name="chevron-right"></bd-fa></div>
                </a>
                <!-- </div> -->
            </div>
        </div>
    </div>
</div>

<!-- <contact-widget></contact-widget> -->
